import { render, staticRenderFns } from "./RbSpacer.vue?vue&type=template&id=1eac174c&"
import script from "./RbSpacer.vue?vue&type=script&lang=js&"
export * from "./RbSpacer.vue?vue&type=script&lang=js&"
import style0 from "./RbSpacer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports